<template>
  <Modal
    v-model:visible="isVisible"
    :header="t('multistop.rearrangeStops')"
    class="multistop-arrangeable-stop-list-modal"
    @keypress.enter="onSave"
  >
    <p>
      <span>{{ t('multistop.rearrangeStopsInstructions') }}</span>
      <span v-if="shipment.id" :style="{ 'margin-left': 'var(--sp-1)' }">
        {{ t('multistop.rearrangeStopsExecutionWarning') }}
      </span>
    </p>

    <ArrangeableShipmentStopList
      v-if="shipment"
      :id="`${uid}-proposed-shipment-loation-section`"
      v-model:shipment="shipment"
      tabindex="-1"
    />

    <template #footer>
      <RygenButton
        mode="tertiary"
        :label="t('common.cancel')"
        @click="onCancel"
      />
      <RygenButton
        mode="primary"
        icon="pi pi-sort-alt"
        :label="t('common.confirm')"
        @click="onSave"
      />
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { ref, toRefs, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { useUid } from '@rygen/rygen-ui/composables';

import { Shipment } from '@/model';

import ArrangeableShipmentStopList from '@/components/multistop/ArrangeableShipmentStopList.vue';
import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';
import Modal from '@rygen/rygen-ui/components/ui/Modal.vue';

const isVisible = defineModel('visible', {
  type: Boolean,
  default: () => false,
});

const props = defineProps({
  modelValue: {
    type: Shipment,
    default: () => new Shipment(),
  },
});
const { modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', shipment: Shipment): void;
}>();

const { t } = useI18n();
const { uid } = useUid('multistop-arrangeable-stop-list-modal');

const shipment = ref(new Shipment());

function onSave() {
  emit('update:model-value', shipment.value);
  isVisible.value = false;
}

function onCancel() {
  shipment.value = new Shipment(modelValue.value);
  isVisible.value = false;
}

watch(
  modelValue,
  (newVal: Shipment) => {
    shipment.value = new Shipment(newVal);
  },
  { immediate: true, deep: true },
);
</script>

<style>
.multistop-arrangeable-stop-list-modal {
  .proposed-shipment-stop-list {
    margin-top: var(--sp-6);
  }
}
</style>
